type UseLangMap = () => {
  getFullNameForLanguage: (langDict: Array<string>) => string
}

const useLangMap: UseLangMap = () => {
  const getFullNameForLanguage = (langDict: Array<string>) => {
    const langDictCopy = [...langDict]
    const lastLanguage = langDict.length > 1 ? langDictCopy.pop() : undefined
    const languages = langDictCopy.join(', ')

    return `
      ${languages}
      ${lastLanguage ? ` & ${lastLanguage}` : ''}
    `
  }

  return { getFullNameForLanguage }
}

export default useLangMap
